import { Component, OnInit, Input, effect } from '@angular/core';
import { FormComponentLookup, FormPageComponentClass, EntryConfigInterface, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';

import { FormConfig } from '@ptl/forms';
import { NgRedux, select } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';


import { plansNeedRefreshedFromBackend } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ContentStorageService } from '@ptl/global-components';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';


@FormComponentLookup('page-create-family')
@Component({
    selector: 'app-page-create-family',
    templateUrl: './page-create-family.component.html',
    styleUrls: ['./page-create-family.component.scss'],
    standalone: false
})

export class PageCreateFamilyComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  displaySpinner = false;

  proxySEPForm: UntypedFormGroup;
  configSEPFlagObj: EntryConfigInterface;
  contentStorageSubscription: Subscription;
  contentStorageKey = 'SpecialEnrollmentPeriodContent';

  constructor(
    protected ngRedux: NgRedux<StateStructure>,
    private snackBar: MatSnackBar,
    private contentStorageService: ContentStorageService,
    private fb: UntypedFormBuilder,
    private reducerUtilityService: ReducerUtilityService
  ) {
    super();
  }

  ngOnInit() {
    this.resetFormData();
    this.initPageConfig();
    
    /**
     * If page is NOT configured for SEP, reset any SEP related values
     */
    this.contentStorageSubscription = this.contentStorageService.contentChanged$.subscribe(async () => {
      const content = this.contentStorageService.getContentMap(this.contentStorageKey);
      if (content?.size > 0) {
        if (content.get('isSEP') && content.get('isSEP') === 'false') {
          // not SEP
          
          /** Config from .custom in json */
          this.configSEPFlagObj = this.formConfig.pages[this.currentPage].entries.find(e => e.custom?.isSEPStateControl);
          
          const configConnectPath = this.configSEPFlagObj?.formControlAttributes?.connectPath;
          if (configConnectPath) {
            
            /** This form exists just to trigger an update to the appropriate control */
            this.proxySEPForm = (this.pageFormGroups[configConnectPath] as UntypedFormGroup);

            /** Wait for form to be [connect]ed to the template */
            setTimeout(() => { 
              const payloadStates = this.reducerUtilityService.getPayloadStates();
              const configConnectPathState = payloadStates[configConnectPath];
              
              if (configConnectPathState) {
               
                Object.keys(configConnectPathState).forEach(cName => {
                  
                  if (!this.proxySEPForm.get(cName)) {
                    this.proxySEPForm.addControl(cName, this.fb.control(null));
                  }

                  const c: AbstractControl = this.proxySEPForm.get(cName);
                  c.reset();
                  c.updateValueAndValidity();

                }) 
              }
              
            }, 100)
          }
          
        } else {
          // SEP
        }
      }
    });

  }

  resetFormData() {}

  saveForLaterButtonClick(event: Event){
    if(event){
      this.saveForLaterButton();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  nextButtonClick(event: Event){
    if(event){
        this.nextButton();
      if(!this.formConfig.form.formNavigation?.nextButton?.redirect){
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  backButtonClick(event: Event){
    if(event){
      this.backButton();
      if(!this.formConfig.form.formNavigation?.backButton?.redirect){
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  submitButtonClick(event: Event){
    if(event){
      this.submitButton();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  nextHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      this.formPageActions.nextHook(formConfig);
      resolve(resolve);
    });
  }

  backHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      this.formPageActions.backHook(formConfig);
      resolve(resolve);
    });
  }

  submitHook(): Promise<any> {
    return new Promise((resolve, reject) => {

      let urlRedirect = this.formConfig?.pages[this.currentPage]?.custom?.redirectUrl;
      // update state with refreshWatcherData
      this.ngRedux.dispatch(plansNeedRefreshedFromBackend(true));

      if(this.formConfig?.pages[this.currentPage]?.custom?.evenYearRedirectUrl || this.formConfig?.pages[this.currentPage]?.custom?.oddYearRedirectUrl) {  
        const payloadStates = this.reducerUtilityService.getPayloadStates();
        const effectiveDate = payloadStates?.individualMarket?.ratingInfo?.effectiveDate;
        const effDateYear = new Date(effectiveDate).getFullYear();
        urlRedirect = (effDateYear % 2) === 0 ? this.formConfig?.pages[this.currentPage]?.custom?.evenYearRedirectUrl : this.formConfig?.pages[this.currentPage]?.custom?.oddYearRedirectUrl;
      }

      const alertDuration = 1000; // ms

      this.snackBar.open(`Rate Information saved, proceeding to next page.`, 'OK', {
        duration: alertDuration,
        panelClass: 'positive-panel-class'
      });

      if (urlRedirect) {
        setTimeout(() => {
          window.location.assign(urlRedirect);
        }, alertDuration)
      }
      resolve(true);
    });
  }
}
